import React, { useEffect, useState } from "react";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  CircularProgress,
  Alert,
  FormHelperText,
} from "@mui/material";
import { IoInformationCircleOutline } from "react-icons/io5";
import PortfolioPieChart from "../DashBoard/WeldingStatics/InspectionDonutCard";
import { useDispatch, useSelector } from "react-redux";
import {
  GetDashboardErrorWeldDetails,
  GetDashboardFormStatusStatics,
  GetDashboardInspectionBreakdownDetails,
  GetDashboardMaterialToolClassification,
  GetDashboardMaterialToolLocation,
  GetDashboardOperatorSummary,
  GetDashboardWeldCountByWelderDetails,
  GetDashboardWelderSummary,
  GetDashboardWeldLogOtherCountDetails,
  GetDashboardWeldLogRejectCountDetails,
  GetDashboardWeldStatics,
  GetDashboardWeldTostaSystemStatics,
  GetMaterialToolStatics,
  GetProjectStatics,
} from "../../../redux/action/DashbardAction/DashboardAction";
import {
  Operator_Summary_Table_Header,
  ProjectFormData,
  Welder_Summary_Table_Header,
} from "../../utils/helperData";
import ApexChart from "../DashBoard/WeldingStatics/ApexRealChart"
import StackedBarChart from "../DashBoard/WeldingStatics/StackedColumn";
import DashboardStaticsTable from "../DashBoard/WeldingStatics/DashboardStaticsTable";
import RejectedWeldsTable from "../DashBoard/WeldingStatics/ApexDataTable";
import InspectionBreakdown from "../DashBoard/DashboardBreakDownCard/BreakdownCard";
import ApexDonutPieChart from "../DashBoard/DonutCard/ApexDonutpieChart";
import StackedColumnBarChart from "../DashBoard/WeldingStatics/WeldsTotalSystem";
import MaterialToolStaked from "../DashBoard/WeldingStatics/MaterialToolStaked";
import OperatoSummaryTable from "../DashBoard/WeldingStatics/OperatorSummary";
import MaterialTotalTable from "../DashBoard/WeldingStatics/MaterialTotalTable";
import { fetchDataProjectList } from "../../../redux/action/DataVerification/DataverificationAction";
import DateRangePicker from "../../customComponent/DatePicker/DatePicker";
import { useParams } from "react-router";

const WeldingAnalytics = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const { loading: projectLoading, error: projectListError } = useSelector(
    (state) => state.project
  );

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [projectStaticsError, setProjectStaticsError] = useState(null);
  const [materialToollocError, setMaterialToollocError] = useState(null);
  const [materialToolclassError, setMaterialToolclassError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedClassification, setSelectedClassification] = useState("");
  const [inspectionProject, setInspectionProject] = useState("");
  const [selectedFormName, setSelectedFormName] = useState(null);

  useEffect(() => {
    dispatch(fetchDataProjectList());
  }, [dispatch]);

  const {
    dashboardProjectCount,
    dashboardFormStatusCount,
    dashboardWeldTotalBySystem,
    isLoading: projectStaticsLoading,
    dashboardWeldProject,
    dashboardMaterialToolClassification,
    dashboardMaterialToolLocation,
    dashboardWeldLogRejectionCount,
    dashboardWeldLogOtherTypeCount,
    dasboardErrorWeldLog,
    dashboardMaterialTool,
    dashboardOperatorSummary,
    dashboardWelderSummary,
  } = useSelector((state) => state.dashboard);

  const locss = dashboardMaterialToolLocation?.data || [];
  const classif = dashboardMaterialToolClassification?.data || [];

  const fetchMaterialToolStats = (
    projectId,
    classification,
    location,
    dateRange
  ) => {
    if (projectId) {
      dispatch(
        GetMaterialToolStatics(
          projectId,
          classification,
          location,
          dateRange,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );
    }
  };

  const handleLocationChange = (event) => {
    const locat = event.target.value;
    setSelectedLocation(locat);
    fetchMaterialToolStats(
      projectId,
      selectedClassification,
      locat,
      `${selectedStartDate || ""}:${selectedEndDate || ""}`
    );
  };

  const handleClassificationChange = (event) => {
    const classifica = event.target.value;
    setSelectedClassification(classifica);
    fetchMaterialToolStats(
      projectId,
      classifica,
      selectedLocation,
      `${selectedStartDate || ""}:${selectedEndDate || ""}`
    );
  };

  const [prevDateRange, setPrevDateRange] = useState({
    start: selectedStartDate,
    end: selectedEndDate,
  });

  const handleDateRangeChange = (startDate, endDate) => {
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);
  };

  const handleInspectionChange = (e) => {
    const selectedValue = e.target.value;
    const selectedForm = ProjectFormData?.find(
      (form) => form.value === selectedValue
    );

    setInspectionProject(selectedValue);
    setSelectedFormName(selectedForm?.form_name || null);
  };

  const fetchStatistics = (
    projectId,
    startDate,
    endDate,
    formName,
    location,
    classification
  ) => {
    if (projectId) {
      dispatch(
        GetProjectStatics(
          projectId,
          `${startDate || ""}:${endDate || ""}`,
          formName,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardMaterialToolLocation(
          projectId,
          `${startDate || ""}:${endDate || ""}`,
          () => setMaterialToollocError(null),
          (error) => setMaterialToollocError(error)
        )
      );

      dispatch(
        GetDashboardMaterialToolClassification(
          projectId,
          `${startDate || ""}:${endDate || ""}`,
          () => setMaterialToolclassError(null),
          (error) => setMaterialToolclassError(error)
        )
      );

      fetchMaterialToolStats(
        projectId,
        classification,
        location,
        `${startDate || ""}:${endDate || ""}`
      );

      dispatch(
        GetDashboardWeldCountByWelderDetails(
          projectId,
          formName,
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );
      dispatch(
        GetDashboardWeldStatics(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          formName,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardInspectionBreakdownDetails(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardWeldTostaSystemStatics(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardWeldLogRejectCountDetails(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardWeldLogOtherCountDetails(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardErrorWeldDetails(
          projectId || "",
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardFormStatusStatics(
          projectId || "",
          `${startDate || ""}:${endDate || ""}`,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardOperatorSummary(
          projectId,
          `${startDate || ""}:${endDate || ""}`,
          formName,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );

      dispatch(
        GetDashboardWelderSummary(
          projectId,
          `${startDate || ""}:${endDate || ""}`,
          formName,
          () => setProjectStaticsError(null),
          (error) => setProjectStaticsError(error)
        )
      );
    }
  };

  useEffect(() => {
    if (
      selectedStartDate !== prevDateRange.start ||
      selectedEndDate !== prevDateRange.end ||
      projectId
    ) {
      fetchStatistics(
        projectId,
        selectedStartDate,
        selectedEndDate,
        selectedFormName
      );
      setPrevDateRange({ start: selectedStartDate, end: selectedEndDate });
    }
  }, [
    dispatch,
    projectId,
    selectedStartDate,
    selectedEndDate,
    selectedFormName,
  ]);

  if (
    !dashboardOperatorSummary ||
    !dashboardWeldLogRejectionCount ||
    !dashboardMaterialToolLocation ||
    !dashboardMaterialToolClassification
  ) {
    return <div>Loading...</div>;
  }

  const fieldData =
    dashboardWeldLogRejectionCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Field"
    )?.defects || [];
  const shop1Data =
    dashboardWeldLogRejectionCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Shop 1"
    )?.defects || [];
  const shop2Data =
    dashboardWeldLogRejectionCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Shop 2"
    )?.defects || [];

  const fieldOtherData =
    dashboardWeldLogOtherTypeCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Field"
    )?.other_ins_type || [];
  const shop1OtherData =
    dashboardWeldLogOtherTypeCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Shop 1"
    )?.other_ins_type || [];
  const shop2OtherData =
    dashboardWeldLogOtherTypeCount?.data?.find(
      (loc) => loc?.loc_name?.trim() === "Shop 2"
    )?.other_ins_type || [];

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 md:space-y-0">
        <FormControl
          size="medium"
          className="w-full md:w-auto flex-1"
          error={!!projectListError}
        >
          <InputLabel id="inspections-select-label">
            Select Inspection Form Type
          </InputLabel>
          <Select
            labelId="inspections-select-label"
            id="inspections-select"
            value={inspectionProject}
            label="Select Inspection Form Type"
            onChange={handleInspectionChange}
            disabled={projectLoading}
            startAdornment={
              projectLoading ? <CircularProgress size={20} /> : null
            }
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  overflowY: "auto",
                },
              },
            }}
          >
            <MenuItem value="">
              <em>Select Project</em>
            </MenuItem>
            {ProjectFormData?.map((project, i) => (
              <MenuItem key={project.value} value={project?.value}>
                {project?.name}
              </MenuItem>
            ))}
          </Select>
          {projectListError && (
            <Alert severity="error" className="mt-2">
              {projectListError}
            </Alert>
          )}
        </FormControl>
        <div className="w-full">
          <DateRangePicker onDateRangeChange={handleDateRangeChange} />
        </div>
      </div>
      {projectStaticsError && (
        <Alert severity="error" className="mb-4">
          {projectStaticsError}
        </Alert>
      )}
      {projectStaticsLoading && (
        <div className="flex justify-center items-center">
          <CircularProgress />
        </div>
      )}
      {dashboardProjectCount && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="col-span-1 p-8 md:col-span-2 flex bg-white shadow-lg justify-between rounded-lg">
            <div className="flex flex-col justify-between h-full">
              <div className="flex items-center justify-between gap-4">
                <p className="text-2xl font-semibold font-poppins text-[#464255]">
                  {inspectionProject === 295
                    ? "TOTAL WELDS"
                    : "TOTAL INSPECTION"}
                </p>
                <p className="text-2xl font-semibold font-poppins text-[#464255]">
                  {dashboardProjectCount?.total || 0}
                </p>
              </div>

              <div className="flex flex-col mt-4">
                <p className="text-sm text-orange-500 mt-2 flex items-center">
                  <IoInformationCircleOutline className="w-4 h-4 mr-2" />
                  <span className="font-bold">TOTAL COMPLETED:</span>&nbsp;
                  {dashboardProjectCount?.total_completed || 0} (
                  {(
                    ((dashboardProjectCount?.total_completed || 0) /
                      (dashboardProjectCount?.total || 1)) *
                    100
                  ).toFixed(2)}
                  %)
                </p>
                <p className="text-sm text-orange-500 mt-2 flex items-center">
                  <IoInformationCircleOutline className="w-4 h-4 mr-2" />
                  <span className="font-bold">TOTAL ACCEPTED:</span>&nbsp;
                  {dashboardProjectCount?.total_accepted || 0} (
                  {(
                    ((dashboardProjectCount?.total_accepted || 0) /
                      (dashboardProjectCount?.total || 1)) *
                    100
                  ).toFixed(2)}
                  %)
                </p>
                <p className="text-sm text-orange-500 mt-2 flex items-center">
                  <IoInformationCircleOutline className="w-4 h-4 mr-2" />
                  <span className="font-bold">TOTAL REJECTED:</span>&nbsp;
                  {dashboardProjectCount?.total_rejected || 0} (
                  {(
                    ((dashboardProjectCount?.total_rejected || 0) /
                      (dashboardProjectCount?.total || 1)) *
                    100
                  ).toFixed(2)}
                  %)
                </p>
              </div>
            </div>

            <div style={{ width: "100%", maxWidth: "580px", margin: "auto" }}>
              <PortfolioPieChart
                inspectiondatalist={dashboardProjectCount}
                defaultValue
              />
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
            <div className="p-4 bg-white shadow-lg rounded-lg">
              <div className="flex justify-between items-center">
                <p className="text-lg font-bold font-poppins text-[#464255]">
                  {/* FIELD TOTAL WELDS */}
                  {inspectionProject === 295
                    ? "FIELD TOTAL WELDS"
                    : "FIELD TOTAL INSPECTION"}
                </p>
                <p className="text-2xl font-bold">
                  {dashboardProjectCount?.data[1]?.count || 0}
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-2 text-sm text-gray-500">
                <p>
                  <span className="font-bold">Completed: </span>
                  {dashboardProjectCount?.data[1]?.completed_count || 0}
                </p>
                <p>
                  <span className="font-bold">Accepted: </span>
                  {dashboardProjectCount?.data[1]?.accepted_count || 0}
                </p>
                <p>
                  <span className="font-bold">Rejected: </span>
                  {dashboardProjectCount?.data[1]?.rejected_count || 0}
                </p>
              </div>
            </div>

            <div className="p-4 bg-white shadow-lg rounded-lg">
              <div className="flex justify-between items-center">
                <p className="text-lg font-bold font-poppins text-[#464255]">
                  {/* SHOP 1 TOTAL WELDS */}
                  {inspectionProject === 295
                    ? "SHOP 1 TOTAL WELDS"
                    : "SHOP 1 TOTAL INSPECTION"}
                </p>
                <p className="text-2xl font-bold">
                  {dashboardProjectCount?.data[0]?.count || 0}
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-2 text-sm text-gray-500">
                <p>
                  <span className="font-bold">Completed: </span>
                  {dashboardProjectCount?.data[0]?.completed_count || 0}
                </p>
                <p>
                  <span className="font-bold">Accepted: </span>
                  {dashboardProjectCount?.data[0]?.accepted_count || 0}
                </p>
                <p>
                  <span className="font-bold">Rejected: </span>
                  {dashboardProjectCount?.data[0]?.rejected_count || 0}
                </p>
              </div>
            </div>

            <div className="p-4 bg-white shadow-lg rounded-lg">
              <div className="flex justify-between items-center">
                <p className="text-lg font-bold font-poppins text-[#464255]">
                  {/* SHOP 2 TOTAL WELDS */}
                  {inspectionProject === 295
                    ? "SHOP 2 TOTAL WELDS"
                    : "SHOP 2 TOTAL INSPECTION"}
                </p>
                <p className="text-2xl font-bold">
                  {dashboardProjectCount?.data[2]?.count || 0}
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-2 text-sm text-gray-500">
                <p>
                  <span className="font-bold">Completed: </span>
                  {dashboardProjectCount?.data[2]?.completed_count || 0}
                </p>
                <p>
                  <span className="font-bold">Accepted: </span>
                  {dashboardProjectCount?.data[2]?.accepted_count || 0}
                </p>
                <p>
                  <span className="font-bold">Rejected: </span>
                  {dashboardProjectCount?.data[2]?.rejected_count || 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-8 gap-4 mt-12">
        <div className="col-span-5">
          <InspectionBreakdown />
        </div>
        <div className="col-span-3">
          <ApexDonutPieChart inspectionProject={inspectionProject} />
        </div>
      </div>

      <div className="mt-12">
        <p className="text-2xl font-semibold font-poppins text-[#464255]">
          Data Verification
        </p>
        <DashboardStaticsTable data={dasboardErrorWeldLog} />
      </div>

      <div className="mt-12">
        <p className="text-2xl font-semibold font-poppins text-[#464255]">
          Inspector Summary
        </p>
        <OperatoSummaryTable
          data={dashboardOperatorSummary}
          tableHeader={Operator_Summary_Table_Header}
        />
      </div>
      <div className="mt-12">
        <p className="text-2xl font-semibold font-poppins text-[#464255]">
          Welder Summary
        </p>
        <OperatoSummaryTable
          data={dashboardWelderSummary}
          tableHeader={Welder_Summary_Table_Header}
        />
      </div>
      <div className="grid grid-cols-8 gap-4 mt-12">
        <div className="col-span-6">
          <p className="text-2xl font-semibold font-poppins text-[#464255]">
            {/* Field Welds (By Weld Date) */}
            {inspectionProject === 295
              ? "Field Welds (By Weld Date)"
              : "Field Inspection (By Inspection Date)"}
          </p>
          <ApexChart
            data={dashboardWeldProject?.result}
            location="Field"
            inspectionProject={inspectionProject}
          />
        </div>

        <div className="col-span-2 flex flex-col h-[525px]">
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide pb-4">
            <RejectedWeldsTable
              // title="Field Rejected Welds"
              title={
                inspectionProject === 295
                  ? "Field Rejected Welds"
                  : "Field Rejected Inspection"
              }
              subtitle="Reason"
              data={fieldData?.map((defect) => ({
                reason: defect?.weld_defect,
                count: defect?.count,
              }))}
            />
          </div>
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide">
            <RejectedWeldsTable
              title="Other Inspection Type"
              subtitle="Inspection Type"
              data={fieldOtherData?.map((othe) => ({
                reason: othe?.other_ins_type,
                count: othe?.count,
              }))}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-8 gap-4 mt-12">
        <div className="col-span-6">
          <p className="text-2xl font-semibold font-poppins text-[#464255]">
            {/* Shop 1 Welds (By Weld Date) */}
            {inspectionProject === 295
              ? "Shop 1 Welds (By Weld Date)"
              : "Shop 1 Inspection (By Inspection Date)"}
          </p>
          <ApexChart
            data={dashboardWeldProject?.result}
            location="Shop 1"
            inspectionProject={inspectionProject}
          />
        </div>
        <div className="col-span-2 flex flex-col h-[525px]">
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide pb-4">
            <RejectedWeldsTable
              // title="Shop 1 Rejected Welds"
              title={
                inspectionProject === 295
                  ? "Shop 1 Rejected Welds"
                  : "Shop 1 Rejected Inspection"
              }
              subtitle="Reason"
              data={shop1Data?.map((defect) => ({
                reason: defect.weld_defect,
                count: defect?.count,
              }))}
            />
          </div>
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide">
            <RejectedWeldsTable
              title="Other Inspection Type"
              subtitle="Inspection Type"
              data={shop1OtherData?.map((othe) => ({
                reason: othe?.other_ins_type,
                count: othe?.count,
              }))}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-8 gap-4 mt-12">
        <div className="col-span-6">
          <p className="text-2xl font-semibold font-poppins text-[#464255]">
            {/* Shop 2 Welds (By Weld Date) */}
            {inspectionProject === 295
              ? "Shop 2 Welds (By Weld Date)"
              : "Shop 2 Inspection (By Inspection Date)"}
          </p>
          <ApexChart
            data={dashboardWeldProject?.result}
            location="Shop 2"
            inspectionProject={inspectionProject}
          />
        </div>
        <div className="col-span-2 flex flex-col h-[525px]">
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide pb-4">
            <RejectedWeldsTable
              // title="Shop 2 Rejected Welds"
              title={
                inspectionProject === 295
                  ? "Shop 2 Rejected Welds"
                  : "Shop 2 Rejected Inspection"
              }
              subtitle="Reason"
              data={shop2Data?.map((defect) => ({
                reason: defect.weld_defect,
                count: defect.count,
              }))}
            />
          </div>
          <div className="flex-1 bg-gray-100 overflow-scroll scrollbar-hide">
            <RejectedWeldsTable
              title="Other Inspection Type"
              subtitle="Inspection Type"
              data={shop2OtherData?.map((othe) => ({
                reason: othe?.other_ins_type,
                count: othe.count,
              }))}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-8 gap-6 mt-12">
        <div className="col-span-4">
          <p className="text-2xl font-semibold mb-3 font-poppins text-[#464255]">
            Form Status
          </p>
          <StackedBarChart data={dashboardFormStatusCount?.result} />
        </div>
        <div className="col-span-4">
          <p className="text-2xl font-semibold mb-3 font-poppins text-[#464255]">
            {/* Welds Total By System */}
            {inspectionProject === 295
              ? "Welds Total By System"
              : "Inspection Total By System"}
          </p>
          <StackedColumnBarChart data={dashboardWeldTotalBySystem?.result} />
        </div>
      </div>

      <div className="mt-12">
        <p className="text-2xl mt-12 font-semibold mb-6 font-poppins text-[#464255] text-center md:text-left">
          Material Totals
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:space-y-0">
          <FormControl sx={{ m: 1 }} error={!!materialToollocError}>
            <Select
              value={selectedLocation}
              onChange={handleLocationChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>Select Location</em>
              </MenuItem>
              {locss.map((loca, i) => (
                <MenuItem key={i} value={loca.name}>
                  {loca.name}
                </MenuItem>
              ))}
            </Select>
            {materialToollocError && (
              <FormHelperText>{materialToollocError}</FormHelperText>
            )}
          </FormControl>
          <FormControl sx={{ m: 1 }} error={!!materialToolclassError}>
            <Select
              value={selectedClassification}
              onChange={handleClassificationChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>Select Classification</em>
              </MenuItem>
              {classif.map((cls, i) => (
                <MenuItem key={i} value={cls.name}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
            {materialToolclassError && (
              <FormHelperText>{materialToolclassError}</FormHelperText>
            )}
          </FormControl>
        </div>
      </div>

      <div className="grid grid-cols-8 gap-6">
        <div className="col-span-6">
          <MaterialToolStaked data={dashboardMaterialTool} />
        </div>
        <div className="col-span-2">
          <MaterialTotalTable
            title="Material Total Count"
            data={dashboardMaterialTool}
          />
        </div>
      </div>
    </div>
  );
};

export default WeldingAnalytics;
